import { ICarouselSlide } from 'libs/ui/carousel/src/lib/carousel/interfaces/carousel-slide.interface';
import { HomeBannerDto, HomePageBannerSectionType } from '../models/banner.model';

const parseBannerToCarousel = ({ order, sections, sourceSet }: HomeBannerDto): ICarouselSlide => {
  let header = '';
  let title = '';
  let description = '';
  let actionTitle = '';
  let subtitle = '';
  let link = '';
  sections.forEach(({ type, value, link: sectionLink }) => {
    switch (type) {
      case HomePageBannerSectionType.Header:
        header = value || '';
        break;
      case HomePageBannerSectionType.Title:
        title = value || '';
        break;
      case HomePageBannerSectionType.Subtitle:
        subtitle = value || '';
        break;
      case HomePageBannerSectionType.Description:
        description = value || '';
        break;
      case HomePageBannerSectionType.ActionTitle:
        actionTitle = value || '';
        link = sectionLink || link;
        break;
    }
  });

  return {
    id: order,
    title,
    subtitle,
    header,
    description,
    sourceSet,
    link,
    actionTitle,
  };
};
export const bannersToCarousel = (banners: HomeBannerDto[]): ICarouselSlide[] => banners.map(parseBannerToCarousel);
